import React, { useState } from 'react';
import Login from './components/auth/Login';
import Dashboard from './pages/Dashboard';
import CyberBackground from './components/layout/CyberBackground';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const handleLogin = (credentials: { email: string; password: string }) => {
    // En una aplicación real, aquí habría un proceso de autenticación
    // con el servidor, validaciones, etc.
    console.log('Iniciando sesión con:', credentials);
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    setIsAuthenticated(false);
  };

  return (
    <div className="min-h-screen bg-cyber-dark text-white">
      {/* Fondo animado de ciberseguridad */}
      <CyberBackground />
      
      <div className="min-h-screen flex flex-col">
        {!isAuthenticated ? (
          <div className="flex-1 flex items-center justify-center p-4">
            <Login onLogin={handleLogin} />
          </div>
        ) : (
          <Dashboard onLogout={handleLogout} />
        )}
      </div>
    </div>
  );
}

export default App;